export const SET_SIZE_STATE = (payload: { size: number[]}) => ({
    type: 'SET_SIZE_STATE',
    payload: payload
});  

  